import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    { path: '/devops', label: 'DevOps' },
    { path: '/cloud', label: 'Cloud Services' },
    { path: '/data-science', label: 'Data Science' },
    { path: '/data-engineering', label: 'Data Engineering' },
    { path: '/generative-ai', label: 'Generative AI' },
    { path: '/app-development', label: 'App Development' }
  ];

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3>CloudRaize</h3>
            <p>
              Empowering businesses with cutting-edge IT solutions.
              From cloud infrastructure to AI implementation, we're your
              trusted technology partner for digital transformation.
            </p>
            <div className="social-links">
              <a href="#" className="social-link">Email</a>
              <a href="#" className="social-link">Work</a>
              <a href="#" className="social-link">Social</a>
              <a href="#" className="social-link">Docs</a>
            </div>
          </motion.div>

          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h4>Services</h4>
            <ul>
              {services.map((service) => (
                <li key={service.path}>
                  <Link to={service.path}>{service.label}</Link>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4>Quick Links</h4>
            <ul>
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <h4>Contact Info</h4>
            <div className="contact-info">
              <p>Email: contact@cloudraize.com</p>
              <p>Phone: +91 8106109054</p>
              <p>Address: MIG-59, Om sari sai nilayam, 4th floor, Flot no : 4S, Dharmareddy colony, Kphp colony, Hyderabad, Telangana,-500085</p>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <p>&copy; {currentYear} CloudRaize. All rights reserved.</p>
          <div className="footer-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Cookies Policy</a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
